import React from "react";
import { Controller } from "react-hook-form";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { FormControl, FormHelperText } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePickerProps } from "./TDateTimeProps";

const MUIDateTimePicker: React.FC<DatePickerProps> = ({
  name,
  control,
  label,
  required,
  errors,
  helperText,
  disableFuture,
  disablePast,
}) => {
  const error = Boolean(errors?.[name]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl fullWidth required={required} error={error}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <DateTimePicker
              {...field}
              disableFuture={disableFuture}
              disablePast={disablePast}
              ampm
              label={label}
              value={
                field.value ? dayjs(field.value, "MM/DD/YYYY hh:mm A") : null
              }
              onChange={(date: Dayjs | null) =>
                field.onChange(date ? date.format("MM/DD/YYYY hh:mm A") : null)
              }
              slotProps={{ textField: { error, required } }}
              sx={{
                "& .MuiInputLabel-asterisk": {
                  color: "#F44336",
                },
              }}
            />
          )}
        />
        {error && helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    </LocalizationProvider>
  );
};

export default MUIDateTimePicker;
